import postalCodes from 'postal-codes-js';

var validateZipcode = (zipCode, marketIso) => {
  var isValid = postalCodes.validate(marketIso, zipCode);

  if (isValid === true) {
    return isValid;
  }

  return false;
};

export default validateZipcode;